import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSteamdbComponent } from './simple-icons-steamdb.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSteamdbComponent ],
    exports:      [ SimpleIconsSteamdbComponent ],
    bootstrap:    []
})
export class SimpleIconsSteamdbModule {}
